import { Auth } from 'aws-amplify'

export default async function getAuthusercreds() {


    const usercred = await Auth.currentUserCredentials()
    return usercred
    
}
